<mat-form-field *ngIf="IsRoot" appearance="fill" floatLabel="always" style="width:100%;">
  <mat-label>Parent Category</mat-label>
  <mat-select #CatSelect (selectionChange)="RootSelectionChange($event)" [(value)]="SelectedCategory" canSelectNullableOptions>
    <ng-container *ngFor="let cat of InternalCategories">     
        <mat-option [value]="cat.CategoryID" [ngClass]="['matOptionChild' + cat.NestLevel]">
          <fa-icon *ngIf="cat.NestLevel > 0" [icon]="faTurnUp" class="clickable blue-color rotate-270"></fa-icon>
          {{cat.Name}}
        </mat-option>     
      </ng-container>    
  </mat-select>
</mat-form-field>
